export default 'M2 7.94h.85L12 17.09V23l-7-6.1v.04H2a2 2 0 0 1-2-2v-5c0-1.1.9-2 2-2M12 1v5.91L9.04 3.95z';